export const environment = {
  production: true,
  backend: {
    base_url: 'https://nocodb-educere.sv4.cloud.atla.pro',
    project_suffix: '/api/v1/db/data/noco',
    dowload_suffix: '/download/noco',
    project_name: '/educere-site-v1-dev',
  },
};
